import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../core/modules/shared.module';
import { RouterModule } from '@angular/router';

import { ResetPasswordComponent } from './resetPassword.component';

/**Service file */
import { AuthService } from '../auth.service';
import { UserQueryService } from '../../gql-query-mutation/index';

const routes = [
    {
        path: 'resetPassword',
        component: ResetPasswordComponent,
        resolve: {
            auth: AuthService
        }
    }
];

@NgModule({
    declarations: [
        ResetPasswordComponent
    ],
    imports: [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    providers: [
        /**Service file */
        AuthService,
        /**Query file */
        UserQueryService
    ],
})

export class ResetPasswordModule {

}



// WEBPACK FOOTER //
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/main/content/apps/authentication/resetPassword/resetPassword.module.ts